module.exports = __webpack_public_path__ + "img/kefu.e95cf095.png";